<template>
    <div class="about-au">
      <p class="indent">
      Alcomet AD is a leading Bulgarian producer of flat-rolled and extruded aluminium products, with over 45 years of experience. The company operates a fully integrated manufacturing facility in Shumen, covering the entire downstream production cycle—from billet and coil casting through extrusion and cold rolling to prefabricated components. The plant is equipped with advanced technological solutions and has a total production capacity of 155 thousand tons per year.
      </p>
      <p class="indent">
      By 2020, Alcomet has invested over EUR 160 million in equipment modernization and sustainable manufacturing processes, focusing on the reduction of carbon emissions and improved recycling rates. One of the most extensive investment programme completed in 2020 and involved major capacity expansion in both main production divisions through the acquisition of a new 25 MN HybrEx® SMS extrusion press and 6-high cold-rolling SMS mill.
      </p>

      <h3 class="indent">Automotive Facility</h3>
      <p class="indent">In 2021, Alcomet inaugurated a state-of-the-art facility exclusively focused on automotive products. The highly automated workshop is equipped with advanced machinery from leading European manufacturers, enabling the production of a broad spectrum of aluminium chassis components and parts for electric battery modules. The facility’s capabilities include cutting, punching, CNS machining, washing, passivation, deburring, assembly, laser marking, camera control and detection. These processes ensure precision and quality, meeting the stringent demands of the automotive industry.</p>

      <h3 class="indent">New Investment Project (2023–2026)</h3>
      <p class="indent">In 2023, Alcomet announced an ambitious three-year investment plan valued at EUR 70 million. The project includes the expansion of Rolling Shop 2 and the construction of a new Casting Shop with a modern, high-tech production line for aluminium coils. These investments aim to increase production capacity and support the development of new aluminium alloys, including those used in converter foil and battery components.</p>

      <p class="indent">The project also involves the installation of two new extrusion presses with forces of 19.5 MN and 40 MN, which will significantly boost efficiency and output. As a result, around 160 new jobs will be created, supporting local economic growth.</p>
      <p class="indent">
        In 2024, the Bulgarian government awarded Alcomet a Certificate for a Priority Investment Project in recognition of the initiative’s national importance. This certification highlights the strategic value of the project, strengthens Alcomet’s market position, and supports the company’s profitability and long-term sustainability.</p>



      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/v1.jpg" alt="">
      </p>
      <p class="indent" style="text-align:center;">
        <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/v2.jpg" alt="">
      </p>


      <p class="indent">Alcomet has a strong presence in the European and US market,
          serving the Building and Construction, Automotive, Transportation,
          Packaging, Engineering and Distribution sectors.</p>
        <div class="about-au-img">
            <img v-scroll-reveal.reset src="/static/img/about/au/1.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/2.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/3.jpg" alt="">
            <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p">Today Alcomet ranks among the top 100 Bulgarian companies in terms of income and growth. It is also among the top 100 biggest employers in Bulgaria.</p>
        </div>
        <p class="indent">Alcomet is certified to ISO 9001, ISO 14001, ISO 45001, ISO 27001, EN 15088, IATF 16949, QUALANOD, QUALICOAT, UKCA, TISAX and ASI PERFORMANCE STANDARD V2 and it is strongly engaged
          in programmes effectively addressing the issues of environmental
          protection, waste reduction and resource efficiency. Continuous
          investment in modern technologies and equipment guarantees
          product improvement and sustainable development of the company.</p>
        <iframe width="560" height="500" src="https://www.youtube.com/embed/kOaJrBzodvg" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
h3  {
  text-decoration: underline;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
  font-size:24px;
}
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue